import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  borrower: [],
  mixes: [],
  loanAmount: '',
  period: '',
  id: '',
};

const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    updateOffer: (state, action) => ({ ...state, ...action.payload }),
    resetOffer: () => initialState,
  },
});

export const { updateOffer, resetOffer } = offerSlice.actions;
export default offerSlice.reducer;
